//React
import React from "react"
import { useState, useEffect } from "react"
//Fetch
import axios from "axios"
//Context
import { useAuthContext } from "../../../Hooks/useAuthContext"
//Bootstrap
import { Form } from "react-bootstrap"
//Notifications
import { toast } from "react-toastify"
//Components
import FormControl from "../../../Components/Forms/FormControl"

export default function CreateEditExternalRequestForm({
  externalRequest,
  setExternalRequests,
  setContact,
  updateContacts,
  setShowForm,
}) {
  const { user } = useAuthContext()
  const [form, setForm] = useState({})

  useEffect(() => {
    if (externalRequest) {
      setForm(externalRequest)
    }
  }, [externalRequest])

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (externalRequest) {
      //Edit
      try {
        const res = await axios.post(
          `https://${process.env.REACT_APP_IP}/api/externalRequest/${form.id}`,
          form,
          {
            headers: { Authorization: `bearer ${user.token}` },
          }
        )
        toast.success("Contact updated.")
        setShowForm(false)
        setContact(res.data)
        updateContacts(res.data)
      } catch (err) {
        console.log(err.response)
      }
    } else {
      //create
      try {
        const res = await axios.post(
          `https://${process.env.REACT_APP_IP}/api/externalRequest`,
          form,
          {
            headers: { Authorization: `bearer ${user.token}` },
          }
        )
        toast.success("Request created.")
        setForm({})
        setShowForm(false)
        setExternalRequests((prev) => {
          return [...prev, res.data]
        })
      } catch (err) {
        console.log(err.response)
      }
    }
  }

  return (
    <Form onSubmit={handleSubmit}>
      <div className="mb-3">
        <h4 className="ps-1">Create External Request</h4>

        <div className="d-flex flex-column flex-md-row  ">
          <FormControl
            value={form.name}
            label={"Name"}
            field={"name"}
            setField={setField}
            classes={"col"}
            required
          />
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <button type="submit" className="btn btn-primary">
          Submit
        </button>
      </div>
    </Form>
  )
}
